import React, { Fragment, useState, useEffect } from 'react';
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import FullCalendar from "fullcalendar-reactwrapper";
import Button from "@mui/material/Button";
import "fullcalendar-reactwrapper/dist/css/fullcalendar.min.css";
import { useDispatch, useSelector } from 'react-redux';
import {getUserAttendance, resetUserAttendance} from '../../api/dashboardApi';
import moment from 'moment';

const UserAttendance = () => {
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [defaultDate, setDefaultDate] = useState(new Date());

    const dispatch = useDispatch();
    const fetchUserAttendance = (e, callback) => dispatch(getUserAttendance(e, callback));

    const state = useSelector((state) => state);
    const {dashboardReducer = {}, authenticationReducer = {}} = state || {};
    const {fetchingAttendance, userAttendance = []} = dashboardReducer;
    const {userProfile: {_id} = {}} = authenticationReducer;

    useEffect(() => {
        dispatch(resetUserAttendance());
    }, []);

    const handleSubmit = () => {
        const callback = () => setDefaultDate(fromDate);
        const payload = {
            id: _id,
            startingDate: moment(fromDate).format('YYYY-MM-DD'),
            endDate: moment(toDate).format('YYYY-MM-DD'),
        }
        fetchUserAttendance(payload, callback);
    }

    const onNextClick = () => {
        const newToDate = new Date(toDate);
        const newDefaultDate = new Date(defaultDate);
        const maxMonth = newToDate.getMonth();
        const selectedMonth = newDefaultDate.getMonth();

        if (selectedMonth === maxMonth) return;

        newDefaultDate.setMonth(selectedMonth + 1);
        setDefaultDate(newDefaultDate);
    };

    const onPrevClick = () => {
        const newFromDate = new Date(fromDate);
        const newDefaultDate = new Date(defaultDate);
        const minMonth = newFromDate.getMonth();
        const selectedMonth = newDefaultDate.getMonth();

        if (selectedMonth === minMonth) return;

        newDefaultDate.setMonth(selectedMonth - 1);
        setDefaultDate(newDefaultDate);
    };

    return (
        <Fragment>
            <div className="section-body">
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="header-action">
                            <h1 className="page-title">My Attendance</h1>
                            <ol className="breadcrumb page-breadcrumb">
                                <li className="breadcrumb-item"><span>St. Andrews College</span></li>
                                <li className="breadcrumb-item active" aria-current="page">My Attendance</li>
                            </ol>
                        </div>
                    </div>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                            label="From"
                            inputFormat="dd MMM yyyy"
                            value={fromDate}
                            onChange={(date) => setFromDate(date)}
                            maxDate={new Date()}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    sx={{ width: "16%", outline: "none", marginRight: "1rem" }}
                                    helperText={null}
                                />
                            )}
                        />
                        <DesktopDatePicker
                            label="To"
                            inputFormat="dd MMM yyyy"
                            value={toDate}
                            onChange={(date) => setToDate(date)}
                            maxDate={new Date()}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    sx={{ width: "16%", outline: "none", marginRight: "2rem" }}
                                    helperText={null}
                                />
                            )}
                        />
                        <Stack
                            spacing={3}
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{
                                my: 2,
                                display: "inline-flex",
                                mt: 2,
                                cursor: "pointer",
                            }}
                        >
                            <Tooltip title="Previous month" arrow placement="top">
                                <span onClick={() => onPrevClick()}>
                                    <span
                                        className="iconify"
                                        data-icon="bi:arrow-left-square-fill"
                                        data-width="30"
                                    ></span>
                                </span>
                            </Tooltip>
                            <Tooltip title="Next month" arrow placement="top">
                                <span onClick={() => onNextClick()}>
                                    <span
                                        className="iconify"
                                        data-icon="bi:arrow-right-square-fill"
                                        data-width="30"
                                    ></span>
                                </span>
                            </Tooltip>
                            <Button variant="contained" size="long" onClick={handleSubmit} disabled={fetchingAttendance}>
                                {fetchingAttendance ? <i className="fa fa-circle-o-notch fa-spin fa-fw"></i> : 'Submit'}
                            </Button>
                        </Stack>
                    </LocalizationProvider>
                </div>
            </div>
            <div className="section-body mt-4">
                <div className="container-fluid">
                    <FullCalendar
                        id="calendar"
                        header={{
                            left: "",
                            center: "title",
                            right: ""
                        }}
                        defaultDate={defaultDate}
                        events={userAttendance}
                        displayEventTime={false}
                    />
                </div>
            </div>
        </Fragment>
    );
}

export default UserAttendance;